<script>
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'

export default {
  name: 'HorizontalScrollView',
  components: {
    ChevronLeftIcon,
    ChevronRightIcon
  },
  props: {
    showArrows: {
      type: Boolean,
      default: true
    },
    aspectRatio: {
      type: Number,
      default: 1 / 1
    },
    columns: {
      type: Number,
      default: 2
    },
    gutter: {
      type: String,
      default: '10px'
    },
    margin: {
      type: String,
      default: '50px'
    }
  },
  data: () => ({
    scrollEnd: true,
    scrollStart: true,
    itemCount: 0
  }),
  computed: {
    styles () {
      return {
        container: {
          '--gutter': this.gutter,
          '--aspect-ratio': this.aspectRatio,
          '--margin': this.margin,
          '--item-count': this.itemCount,
          '--columns': this.columns,
          '--scrollbar-width': `${window.innerWidth - document.documentElement.clientWidth}px`
        },
        arrowLeft: {
          '--opacity': this.scrollStart ? 0 : 1
        },
        arrowRight: {
          '--opacity': this.scrollEnd ? 0 : 1
        }
      }
    }
  },
  mounted () {
    this.handleScroll()
    this.itemCount = this.$refs.scrollRef.children.length
  },
  methods: {
    handleArrowClick (direction) {
      const { width } = this.$refs.scrollRef.getBoundingClientRect()
      const { scrollLeft } = this.$refs.scrollRef
      const containerWidth = window.innerWidth
      const itemWidth = (containerWidth - ((2 * this.margin.replace('px', '')) + ((this.columns + 1) * this.gutter.replace('px', '')))) / this.columns
      this.$refs.scrollRef.scrollTo({
        behavior: 'smooth',
        top: 0,
        left: scrollLeft + ((width - itemWidth) * (direction === 'left' ? -1 : 1))
      })
    },
    handleScroll () {
      const { scrollLeft, scrollWidth, clientWidth } = this.$refs.scrollRef
      this.scrollEnd = scrollWidth - scrollLeft === clientWidth
      this.scrollStart = scrollLeft === 0
    }
  }
}
</script>

<template>
  <div
    class="container"
    :style="styles.container"
  >
    <div
      v-if="showArrows"
      class="arrow left"
      :style="styles.arrowLeft"
      @click="handleArrowClick('left')"
    >
      <chevron-left-icon />
    </div>
    <div
      ref="scrollRef"
      class="grid"
      @scroll="handleScroll"
    >
      <div class="margin left" />
      <slot />
      <div class="margin right" />
    </div>
    <div
      v-if="showArrows"
      class="arrow right"
      :style="styles.arrowRight"
      @click="handleArrowClick('right')"
    >
      <chevron-right-icon />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  --container-width: calc(100vw - var(--scrollbar-width));
  --item-width: calc((var(--container-width) - ((2 * var(--margin)) + ((var(--columns) + 1) * var(--gutter)))) / var(--columns));
  --item-height: calc(var(--item-width) * var(--aspect-ratio));
  position: relative;
  .arrow {
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    width: var(--margin);
    background-color: rgba(0, 0, 0, .5);
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    transition: opacity 150ms linear;
    opacity: var(--opacity);
    &.left {
      justify-content: flex-end;
      left: 0;
    }
    &.right {
      justify-content: flex-start;
      right: 0;
    }
    .chevron-left-icon, .chevron-right-icon {
      svg {
        width: var(--margin);
        height: var(--margin);
        max-width: var(--item-width);
        max-height: var(--item-width);
        fill: white;
      }
    }
  }
  .grid {
    display: grid;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    scroll-padding: 0px calc(var(--margin) + var(--gutter));
    grid-column-gap: var(--gutter);
    grid-template-columns: var(--margin) repeat(var(--item-count), var(--item-width)) var(--margin);
    grid-auto-flow: column;
    > * {
      scroll-snap-align: end;
      scroll-snap-stop: always;
      height: var(--item-height);
    }
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    .margin {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
